import { em } from '@mantine/core';

const APP_CONFIG = {
	QUERY_STALE_TIME: 30_000,
	QUERY_CACHE_TIME: 1_800_000,
	QUERY_RETRY: 2,
	EDIT_LOGOUT_TIME: 6,
	SIZE_PER_PAGE: 6,
	TEXTAREA_LIMIT: 200,
	NAVBAR_HEIGHT: 88,
	CREATOR_NAVIGATION_HEIGHT: 60,
	INFINITE_SCROLL_PER_PAGE: 3,
	TABLE_PAGE_SIZES: [10, 25, 50],
	MODAL_WIDTH: 528,
	Z_INDEX: {
		NOTIFICATION: 100,
		DRAWER: 104,
		OVERLAY: 50,
		MODAL: 301,
		SELECT_DROPDOWN: 302,
		SCROLL_TOP: 50,
		DRAGGED_PREVIEW: 500,
		TUTORIAL_OVERLAY: 550,
		TUTORIAL_ITEM: 555,
	},
	ROOT_FONT_SIZE: 16,
	BREAKPOINTS: {
		XS: em(576),
		SM: em(768),
		MD: em(992),
		LG: em(1200),
		XL: em(1408),
	},
	RECAPTCHA_KEY: '6Ld7AaQqAAAAALHJypTershuZpPPos8j1DbVuWD2',
	DEFAULT_LANGUAGE: 'PL',
	QUANTITY: {
		MIN: 1,
		MAX: 100_000,
	},
	COUNTRIES: [
		'Polska',
		'Ukraina',
		'Rumunia',
		'Niemcy',
		'Francja',
		'Włochy',
		'Hiszpania',
		'Portugalia',
		'Holandia',
		'Belgia',
		'Szwajcaria',
		'Austria',
		'Czechy',
		'Słowacja',
		'Węgry',
		'Słowenia',
		'Chorwacja',
		'Grecja',
		'Bułgaria',
		'Turcja',
		'Litwa',
		'Łotwa',
		'Estonia',
	],
} as const;

export default APP_CONFIG;
